import { initialize } from "./initialize"
import MainRouter from "./routes/MainRouter"

initialize(MainRouter)
